import styled from 'styled-components';

export const transition = '0.3s';

export interface BodyWrapperProps {
  isSideOpen: boolean;
  isFormPage?: boolean;
}

export const BodyWrapper = styled.div<BodyWrapperProps>`
  transition: transition;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  font-size: 14px;
  box-shadow: 1px 3px 25px rgba(0, 0, 0, 0.07);
  background-color: ${({isFormPage, theme }) => (isFormPage ? theme.colors.white : theme.colors.background)};
  margin-left: ${(props) => (props.isSideOpen ? '255px' : '100px')};
  margin-top: 0;
  @media screen and (max-width: 576px) {
    margin-left: 0;
  }
`;

export const Body = styled.div`
  min-height: calc(100vh - ${({ theme }) => theme.header.size});
  position: relative;
  padding: 48px 32px;
  padding-top: calc(48px + ${({ theme }) => theme.header.size});
  color: ${({ theme }) => theme.body.color};
`;
